import { SecureAction } from '../secure-actions';

export class NotesSecureAction extends SecureAction {
  public static readonly VIEW: SecureAction = new NotesSecureAction('admin:device:notes|view');

  private constructor(name: string) {
    super(name);
  }
}
